<template>
  <div class="container">
    <div class="confirmation-page">
      <CircleIcon class="confirmation-page__circle-icon">
        <TickIcon />
      </CircleIcon>
      <QuestionTitle
        class="confirmation-page__title"
        :title="titleMessage"
        subtitle="They'll call you from our London office on an 0800 number"
      />
      <CardBox class="confirmation-page__card-box">
        <ConfirmationSVG class="confirmation-page__card-box__img" />
        <InPageTitle class="confirmation-page__card-box__title">
          What to expect on the call
        </InPageTitle>
        <p class="confirmation-page__card-box__text">
          Your expert will work with you refine the information you have given us so far,
          identify the right features and hardware that match your business requirements and
          compare matching solutions across our providers.
        </p>
        <InPageLink :link-href="'https://bionic.co.uk/about-bionic/'" :target-blank="'_blank'" class="confirmation-page__card-box__link">
          Learn more about Bionic <ArrowIcon class="confirmation-page__card-box__arrow" />
        </InPageLink>
      </CardBox>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import IsOfficeOpen from '@mic/frontend/mixins/IsOfficeOpen'
import CircleIcon from '@/components/icons/CircleIcon'
import TickIcon from '@/components/icons/TickIcon'
import QuestionTitle from '@/components/question/QuestionTitle'
import CardBox from '@/components/ui/CardBox'
import InPageTitle from '@/components/typography/InPageTitle'
import InPageLink from '@/components/typography/InPageLink'
import ArrowIcon from '@/components/icons/ArrowIcon'
import ConfirmationSVG from '@/components/svg/icons/ConfirmationSVG'

export default {
  name: 'ConfirmationPage',
  components: {
    CircleIcon,
    TickIcon,
    CardBox,
    QuestionTitle,
    InPageTitle,
    InPageLink,
    ArrowIcon,
    ConfirmationSVG
  },
  mixins: [IsOfficeOpen],
  computed: {
    ...mapState(['CallBack']),
    ...mapGetters(['formattedDate', 'formattedTimeSuffixed']),
    scheduledDay () {
      const weekday = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      const d = new Date(this.CallBack.contactDateTime)
      let day = weekday[d.getDay()]
      return day
    },
    scheduled () {
      return this.CallBack.contactDateTime
    },
    titleMessage () {
      if (!this.scheduled) return 'Your consultation is all set up and your expert will call in a few minutes'
      return `Your consultation is all set up and your expert will call you on ${this.scheduledDay}, ${this.formattedDate} ${this.formattedTimeSuffixed}`
    }
  }

}
</script>
<style lang="scss">
  .confirmation-page {
    &__title {
      .title {
        @media (min-width: $screen-md) {
          max-width: 570px;
        }
      }
    }
  }
</style>

<style lang="scss" scoped>
  .confirmation-page {
    padding-top: $spacing-64;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__title {

      .title {
      @media (min-width: $screen-md) {
          max-width: 560px;
      }
    }
    }

    &__circle-icon {
      margin-bottom: 15px;

      @media (min-width: $screen-md) {
         margin-bottom: 25px;
      }
    }

    &__card-box {
      margin-left: auto;
      margin-right: auto;
      text-align: left;

      @media (min-width: $screen-md) {
         margin-top: 32px;
      }

      &__img {
        width: 64px;
        height: 64px;
        margin-bottom: 20px;
      }

      &__title,
      &__text {
        text-align: left;
      }

      &__text {
        font-size: 12px;
        line-height: 17.6px;
        margin-top: 12px;
        margin-bottom: 15px;
        color: #5a5a5a;

        @media (min-width: $screen-md) {
          line-height: 19.6px;
          font-size: 14px;
          margin-bottom: 18px;
        }
      }

      &__link {
        display: flex;
        align-items: center;
        font-size: 12px;

         @media (min-width: $screen-md) {
          font-size: 14px;
        }
      }

      &__arrow {
        margin-left: 12px;
        position: relative;
        top: 2px;
      }
    }
  }
</style>
